export default __webpack_public_path__ + "static/media/footer-bg.77c98c7b.png";